import { Site } from '@envato/foundation-types'
import isEmpty from 'lodash-es/isEmpty'
import get from 'lodash-es/get'

import { IExperimentsConfig } from '../../config/experiments'
import { getConfigBySite } from '../../config/sites'
import { ICommonLocation } from './location/types'

export const isExperimentRunning = ({
  experimentsConfig,
  experimentName,
  currentSite,
  location
}: {
  experimentsConfig: IExperimentsConfig
  experimentName: string
  currentSite: Site
  location: ICommonLocation
}) => {
  const experiment = experimentsConfig[experimentName]

  if (!experiment) {
    return false
  }

  const isRunning =
    experiment.running ||
    get(location, 'query.experiment', '') === experimentName
  const isForCurrentSite =
    isEmpty(experiment.sites) || experiment.sites.includes(currentSite)

  const isRunningForCurrentSite = isRunning && isForCurrentSite

  return isRunningForCurrentSite
}

export const shouldDisplayLoadingCover = ({
  experimentsReady,
  experimentsConfig,
  currentSite
}: {
  experimentsReady: boolean
  experimentsConfig: IExperimentsConfig
  currentSite: Site
}) => {
  const isCoverEnabledBySiteConfig = getConfigBySite(
    currentSite,
    'experimentsLoadingCover'
  )
  const isCoverEnabledByExperimentsConfig = Object.keys(experimentsConfig)
    .map(key => experimentsConfig[key])
    .some(expConfig => {
      const isForCurrentSite =
        isEmpty(expConfig.sites) || expConfig.sites.includes(currentSite)
      return isForCurrentSite && !!expConfig.loadingCover
    })

  return (
    (isCoverEnabledByExperimentsConfig || isCoverEnabledBySiteConfig) &&
    !experimentsReady
  )
}
